<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-user-tie"></i> Movimentação de Associados - {{$lang.RelationchipManager.Label}}</h3>
      </div>
    </div>

    <Forms ref="frmGroup"
      :title="'MOVIMENTAÇÃO DE ASSOCIADOS'"
      :showSaveButton="true"
      v-on:Save="openConfirmationModal">
      <div class="form-group row">
        <div class="col-md-4 offset-md-1">
          <label><small v-show="form.paId.required" class="text-danger">*</small> PA:</label>
          <div class="input-group">

            <v-select v-model="form.paId.value"
                      :options="form.paId.options"
                      class="w-100"
                      label="text"
                      :reduce="(opt) => opt.value">
              <template v-slot:no-options>Nenhum pa encontrado.</template>
            </v-select>
          </div>
        </div>

        <div class="col-md-4 offset-md-2 pb-3">
          <label><small v-show="form.gerenteRelacionamentoId.required" class="text-danger">*</small> {{$lang.RelationchipManager.Label}}:</label>
          <div class="input-group">

            <v-select v-model="form.gerenteRelacionamentoId.value"
                      :options="form.gerenteRelacionamentoId.options"
                      class="w-100"
                      label="text"
                      :reduce="(opt) => opt.value">
              <template v-slot:no-options>Nenhum funcionário encontrado.</template>
            </v-select>
          </div>
        </div>

      </div>

      <div class="form-group row pt-3">
        <div class="col-md-3">
          <label>Nome Associado</label>
          <b-form-input
            type="text"
            :placeholder="'Busque pelo Nome associado'"
            v-model="form.nomeAssociado.value"
          ></b-form-input>
        </div>
        <div class="col-md-3">
          <NxSelectFuncionario :variable="employeeTypes.GERENTE" :multiple="false" @update:value="handleSelectGerente($event)"/>
        </div>
        <div class="col-md-2">
          <label>Faixa de Renda:</label>
          <div class="input-group">
            <money
              :placeholder="$lang.Currency.Placeholder"
              class="form-control text-bold"
              max-length="12"
              v-model.lazy="computedRendaInicial"
              v-bind="$lang.Currency.Format"
            ></money>
            <money
              :placeholder="$lang.Currency.Placeholder"
              class="form-control text-bold"
              max-length="12"
              v-model.lazy="computedRendaFinal"
              v-bind="$lang.Currency.Format"
            ></money>
          </div>
        </div>
        <div class="col-md-2">
          <label>Produtor Rural:</label>
          <b-form-radio-group
            v-model="form.isProdutorRural.value"
            aria-describedby="isProdutorRural"
            :required="form.isProdutorRural.required"
          >
            <b-form-radio value="true">Sim</b-form-radio>
            <b-form-radio value="false">Não</b-form-radio>
          </b-form-radio-group>
        </div>
        <div class="col-md-2">
          <label>Tipo Pessoa:</label>
          <b-form-radio-group
            v-model="form.tipoPessoa.value"
            aria-describedby="isProdutorRural"
            :required="form.tipoPessoa.required"
          >
            <b-form-radio value="PF">PF</b-form-radio>
            <b-form-radio value="PJ">PJ</b-form-radio>
          </b-form-radio-group>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 d-flex">
          <div>
            <button
              type="button"
              class="btn btn-third btn-sm"
              v-b-tooltip.hover
              :title="'Pesquisar'"
              @click.prevent="onSearch"
            >
              <i class="fas fa-search"></i>
              <span class="d-md-down-none">
          {{ $lang.Common.Buttons.Search }}
        </span>
            </button>
            <button
              type="button"
              class="btn btn-default btn-sm text-secondary"
              v-on:click="onClear"
              v-b-tooltip.hover
              :title="$lang.Common.Tooltip.ButtonClear"
            >
              <i class="fa fa-minus-circle"></i>
              <span class="d-md-down-none">
          {{ $lang.Common.Buttons.Clear }}
        </span>
            </button>
          </div>
        </div>
      </div>

      <div id="associate-list" style="overflow-y: auto; max-height:70vh;">
        <table class="table table-hover" style="border: 1px solid #dcdede;" >
          <thead class="thead-third" style="border: solid 1px #0277bd; height: 44px;">
            <tr>
              <th class="text-center col-1"><input type="checkbox" v-model="selectAll"></th>
              <th class="text-center">Nome</th>
              <th class="text-center">Numero Sisbr</th>
              <th class="text-center">Tipo Pessoa</th>
              <th class="text-center">Renda</th>
            </tr>
          </thead>
          <tr v-for="associado in associados" :key="associado.id">
            <td v-if="allSelected" class="text-center col-1"><input v-model="allSelected" type="checkbox" checked disabled/></td>
            <td v-else class="text-center col-1"><input v-model="selected" :value="associado.id" type="checkbox"/></td>
            <td class="text-center">{{ associado.nome }}</td>
            <td class="text-center">{{ associado.numSisbr }}</td>
            <td class="text-center">{{ associado.tipoPessoa }}</td>
            <td class="text-center">{{ associado.rendaBrutaMensal }}</td>
          </tr>
        </table>
      </div>
      <AssociatePagination  ref="AssociatePagination" @LoadPage="LoadPage" class="pt-3"></AssociatePagination>
      <div class="d-flex" style="justify-content: end; align-items: start; gap: 1rem; cursor:pointer;" @click="toggleCreateCard">
        <ToogleSwitch :value="createCard"/>
        <h5 style="line-height: 100%">Criar Oportunidade</h5>
      </div>
      <section v-if="createCard" class="create__card__container pb-4">
        <hr>
        <h4 class="mb-4"><i class="fas fa-address-card"></i> Nova Oportunidade</h4>
        <div class="input-group" style="background: none">
          <div class="col-md-6">
            <SelectBoard @onSelect="loadColumns" :onlyActive="true"/>
          </div>
          <div class="col-md-6">
            <SelectBoardColumn v-if="newCard.board" @onSelect="saveBoardAndColumn" :boardId="newCard.board" :key="newCard.board"/>
          </div>
          <div class="col-md-12 pt-3">
            <SelectOrigem v-if="newCard.boardColumn" @onSelect="saveOrigin"/>
          </div>
        </div>
      </section>
      <AddConfirmation ref="AddConfirmationModal"
                       :warnText="`Confirmar movimentação de  ${allSelected ? 'todos':this.selected.length} associados? `"
                       :saveFunction="updateGerentesRelacionamento"/>
    </Forms>
  </div>
  </template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import LinkForm from './link-form'
import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import { JWTService } from '@/shared/services/jwt'
import Roles from '@/shared/utils/roles.js'

import EmployeeRepository from '@/shared/http/repositories/configurations/employee'
import PARepository from '@/shared/http/repositories/configurations/pa'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import AssociatePagination from '@/views/private/associate/pagination/associatepagination.vue'
import SelectBoard from '@/components/forms/selects/SelectBoard.vue'
import SelectBoardColumn from '@/components/forms/selects/SelectBoardColumn.vue'
import SelectOrigem from '@/components/forms/selects/SelectOrigem.vue'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'
import NxSelectFuncionario from '../../../../../components/nexum/components/custom-selects/NxSelectFuncionario.vue'
import employeeTypes from '@/enums/enumEmployeeTypes.js'
import EnvironmentRepository from '../../../../../shared/http/repositories/access/environment'

const dataModel = {
  gerenteRelacionamentoId: null,
  paId: null,
  openCards: false,
  filters: null
}

const dataFilter = {
  paId: null,
  nomeAssociado: null,
  gerenteId: null,
  isProdutorRural: null,
  tipoPessoa: null,
  situacaoContaCapital: 'ATIVO'
}

export default {
  name: 'linkClusters',
  mixins: [ActionsForm],
  data () {
    return {
      data: dataModel,
      dataFilters: dataFilter,
      form: LinkForm,
      roles: Roles,
      permissions: null,
      pageLimit: 50,
      pageIndex: 0,
      currentPage: 0,
      totalElements: 0,
      numberOfElementsDisplayed: 0,
      offset: 0,
      allSelected: false,
      selected: [],
      searchValue: '',
      associados: [],
      createCard: false,
      employeeTypes: employeeTypes,
      rendaInicial: null,
      rendaFinal: null,
      tipoGerente: null,
      newCard: {
        board: null,
        boardColumn: null,
        origin: null
      }
    }
  },
  components: {
    NxSelectFuncionario,
    AddConfirmation,
    AssociatePagination,
    ToogleSwitch,
    SelectBoard,
    SelectBoardColumn,
    SelectOrigem
  },
  computed: {
    selectAll: {
      get: function () {
        return this.allSelected
      },
      set: function () {
        if (this.allSelected) {
          this.allSelected = false
        } else {
          this.allSelected = true
        }
      }
    },
    computedRendaInicial: {
      get: function () {
        // Retorna 0 para o componente filho se rendaInicial for null
        return this.rendaInicial === null ? 0 : this.rendaInicial
      },
      set: function (value) {
        // Se o valor for zero, seta rendaInicial como null
        this.rendaInicial = value === 0 ? null : value
      }
    },
    computedRendaFinal: {
      get: function () {
        // Retorna 0 para o componente filho se rendaInicial for null
        return this.rendaFinal === null ? 0 : this.rendaFinal
      },
      set: function (value) {
        // Se o valor for zero, seta rendaInicial como null
        this.rendaFinal = value === 0 ? null : value
      }
    }
  },
  methods: {
    onLoad () {
      loading.push()
      this.permissions = JWTService.GetRoles()
      if (this.hasRole(this.roles.ADMINISTRADOR)) {
        EmployeeRepository.GetAll()
          .then((res) => {
            this.form.gerenteRelacionamentoId.options = res.data.content.map((x) => ({'value': x.id, 'text': x.pessoa.nome}))
            loading.pop()
          })
          .catch(this.onException)
        PARepository.GetAll()
          .then((res) => {
            loading.pop()
            this.form.paId.options = res.data.content.map((x) => ({'value': x.id, 'text': x.numero + ' - ' + x.descricao}))
          })
          .catch(this.onException)
      } else {
        PARepository.GetAllByUser(JWTService.GetUserName())
          .then((res) => {
            loading.pop()
            this.form.paId.options = res.data.paDTOList.map((x) => ({'value': x.id, 'text': x.numero + ' - ' + x.descricao}))
            this.form.gerenteRelacionamentoId.options = res.data.funcionarioDTOList.map((x) => ({'value': x.id, 'text': x.pessoa.nome}))
          })
          .catch(this.onException)
      }
      EnvironmentRepository.getEnv()
        .then((res) => {
          this.tipoGerente = res.data.tipoPermissao
          loading.pop()
        })
    },
    loadAssociadosPa () {
      loading.push()
      AssociateRepository.Search(
        this.createFilter(),
        this.pageLimit,
        this.pageIndex
      )
        .then((res) => {
          this.associados = res.data.content.map((x) => ({
            id: x.id,
            nome: x.pessoa.nome,
            numSisbr: x.numSisbr,
            clusterAtual: x.clusterizacaoDTO
              ? x.clusterizacaoDTO.descricao
              : '',
            rendaBrutaMensal: x.rendaBrutaMensal
              ? Tools.formatMoneyBR(x.rendaBrutaMensal)
              : '',
            tipoPessoa: x.pessoa.tipoPessoa
          }))
          this.$refs.AssociatePagination.totalPages = res.data.totalPages
          this.$refs.AssociatePagination.totalElements =
            res.data.totalElements
          this.$refs.AssociatePagination.numberOfElementsDisplayed =
            res.data.numberOfElements
          this.$refs.AssociatePagination.offset = res.data.pageable.offset

          loading.pop()
        })
        .catch(this.onException)
    },
    handleSelectGerente (selectedValue) {
      this.form.gerenteId.value = selectedValue.value
    },
    onClear () {
      this.clearForm()
      this.form.nomeAssociado.value = ''
      this.rendaInicial = null
      this.rendaFinal = null
      this.form.gerenteId.value = null
      this.form.paId.value = null
      this.form.isProdutorRural.value = null
      this.form.tipoPessoa.value = null
      this.onClearPaging()
    },
    clearForm () {
      this.$root.$emit('clearForm')
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i] === role) {
            result = true
          }
        }
      }
      return result
    },
    onSearch () {
      this.onClearPaging()
      this.LoadPage(this.pageIndex)
      this.allSelected = false
    },
    onClearPaging () {
      this.currentPage = 0
      this.pageIndex = 0
      this.$refs.AssociatePagination.currentPage = this.currentPage
      this.$refs.AssociatePagination.pageIndex = this.pageIndex
      this.$refs.AssociatePagination.totalElements = this.totalElements
      this.$refs.AssociatePagination.numberOfElementsDisplayed = this.numberOfElements
      this.$refs.AssociatePagination.offset = this.offset
    },
    updateGerentesRelacionamento () {
      // VERIFY IF IS TRYING TO CREATE CARDS AND ALL FIELDS ARE SELECTED
      if (this.createCard && !this.checkFieldsCreateCard()) return
      else if (this.createCard) {
        this.data.openCards = true
        this.data.boardId = this.newCard.board
        this.data.boardColumnId = this.newCard.boardColumn
        this.data.origemLeadId = this.newCard.origin
      }
      if (!Tools.ValidateForms(this.form, this.data, this, toast)) {
        return
      }
      if (this.allSelected) {
        this.data.associadoId = []
        if (!Tools.ValidateForms(this.form, this.dataFilters, this, toast)) {
          toast.warning('Erro na filtragem')
          return
        }
        this.data.filters = {...this.dataFilters, 'rendaInicial': this.rendaInicial, 'rendaFinal': this.rendaFinal}
      } else {
        if (this.selected.length < 1) {
          toast.warning('Nenhum associado selecionado')
          return
        }
        this.data.associadoId = this.selected
      }
      this.data.filtroNome = this.searchValue
      loading.push()
      AssociateRepository.updateAllGerenteRelacionamento(this.data)
        .then(() => {
          toast.success(this.$lang.Common.Alerts.Success)
          this.reloadPage()
          loading.pop()
        })
        .catch(this.onException)
    },
    reloadPage () {
      this.selected = []
      this.searchValue = ''
      this.associados = []
      this.newCard = {
        board: null,
        boardColumn: null,
        origin: null
      }
      this.onSearch()
    },
    LoadPage (index) {
      this.currentPage = index
      this.pageIndex = index
      if (this.searchValue !== null && this.searchValue !== '') {
        this.loadAssociadosPaWithFilter()
      } else {
        this.loadAssociadosPa()
      }
      var obj = document.getElementById('associate-list')
      obj.scrollTo(0, 0)
      // window.scrollTo(0, 0)
    },
    loadAssociadosPaWithFilter () {
      loading.push()
      AssociateRepository.Search(
        this.createFilter(),
        this.pageLimit,
        this.pageIndex
      )
        .then((res) => {
          this.associados = res.data.content.map((x) => ({
            id: x.id,
            nome: x.pessoa.nome,
            numSisbr: x.numSisbr,
            clusterAtual: x.clusterizacaoDTO
              ? x.clusterizacaoDTO.descricao
              : '',
            rendaBrutaMensal: x.rendaBrutaMensal
              ? Tools.formatMoneyBR(x.rendaBrutaMensal)
              : '',
            tipoPessoa: x.pessoa.tipoPessoa
          }))
          this.$refs.AssociatePagination.totalPages = res.data.totalPages
          this.$refs.AssociatePagination.totalElements =
            res.data.totalElements
          this.$refs.AssociatePagination.numberOfElementsDisplayed =
            res.data.numberOfElements
          this.$refs.AssociatePagination.offset = res.data.pageable.offset

          loading.pop()
        })
        .catch(this.onException)
    },
    toggleCreateCard () {
      this.createCard = !this.createCard
      this.newCard = {
        board: null,
        boardColumn: null,
        origin: null
      }
    },
    createFilter () {
      let string = ''
      let params = []
      params.push('situacaoContaCapital=ATIVO')
      if (this.form.paId.value) params.push('paId=' + this.form.paId.value)
      if (this.form.nomeAssociado.value) params.push('nomeAssociado=' + encodeURI(this.form.nomeAssociado.value))

      if (this.form.gerenteId.value) {
        if (this.tipoGerente === 'GERENTERELACIONAMENTO') {
          params.push('gerenteRelacionamentoId=' + this.form.gerenteId.value)
        } else {
          params.push('gerenteSisbrId=' + this.form.gerenteId.value)
        }
      }

      if (this.rendaInicial > 0) params.push('rendaInicial=' + this.rendaInicial)
      if (this.rendaFinal > 0) params.push('rendaFinal=' + this.rendaFinal)
      if (this.form.isProdutorRural.value) params.push('isProdutorRural=' + this.form.isProdutorRural.value)
      if (this.form.tipoPessoa.value) params.push('tipoPessoa=' + this.form.tipoPessoa.value)

      string = params.join('&')

      return string
    },
    loadColumns (boardId) {
      this.newCard.board = boardId
    },
    saveBoardAndColumn (boardAndColumn) {
      this.newCard.board = boardAndColumn[0]
      this.newCard.boardColumn = boardAndColumn[1]
    },
    saveOrigin (origin) {
      this.newCard.origin = origin
    },
    checkFieldsCreateCard () {
      if (this.newCard.board && this.newCard.boardColumn && this.newCard.origin) return true
      else {
        toast.warning('Todos os campos devem estar preenchidos', 'Criar oportunidades')
        return false
      }
    },
    openConfirmationModal () {
      this.$nextTick(() => {
        this.$refs['AddConfirmationModal'].showModal()
      })
    }
  }
}
</script>

<style scoped>
  td{
    background-color: whitesmoke;
  }
  .input-group{
    background-color: whitesmoke;
  }
  thead{ position: sticky; top: 0; z-index: 1; }
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/movimentacoes/gerentesRelacionamento/link.vue